// CursorEffect.js - Effet de curseur personnalisé style forge
import React, { useEffect, useState } from 'react';
import './styles/cursorEffect.css';

const CursorEffect = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isPointer, setIsPointer] = useState(false);
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });

            // Vérifier si on survole un élément cliquable
            const target = e.target;
            const isClickable = 
                target.tagName === 'A' ||
                target.tagName === 'BUTTON' ||
                target.classList.contains('btnBase3') ||
                target.classList.contains('btnBase4') ||
                target.style.cursor === 'pointer' ||
                window.getComputedStyle(target).cursor === 'pointer';

            setIsPointer(isClickable);
        };

        const handleMouseLeave = () => {
            setIsHidden(true);
        };

        const handleMouseEnter = () => {
            setIsHidden(false);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseleave', handleMouseLeave);
        document.addEventListener('mouseenter', handleMouseEnter);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseleave', handleMouseLeave);
            document.removeEventListener('mouseenter', handleMouseEnter);
        };
    }, []);

    // Ne pas afficher sur mobile
    if (window.innerWidth < 768) {
        return null;
    }

    return (
        <>
            {/* Curseur principal */}
            <div 
                className={`cursor-forge ${isPointer ? 'pointer' : ''} ${isHidden ? 'hidden' : ''}`}
                style={{
                    left: `${position.x}px`,
                    top: `${position.y}px`,
                }}
            >
                <div className="cursor-inner"></div>
            </div>

            {/* Traînée du curseur */}
            <div 
                className={`cursor-trail-forge ${isHidden ? 'hidden' : ''}`}
                style={{
                    left: `${position.x}px`,
                    top: `${position.y}px`,
                }}
            />

            {/* Effet d'étincelle au clic */}
            <div 
                className="cursor-spark"
                style={{
                    left: `${position.x}px`,
                    top: `${position.y}px`,
                }}
            />
        </>
    );
};

export default CursorEffect;
